<template>
  <div :style=style>
    <b-card no-body class="border-0">
      <b-list-group>
        <b-list-group-item list-group-item-action class="pointer" v-for="item in listData" :key="item.retail_id"
                           @click="getIdFilter(item.retail_id)"
                           :active="item.retail_id === activeListItem">
          <strong>{{item.retail_name}}</strong> <br>
          <h6>Productos sin movimiento {{item.product_count}}</h6>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  // import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'
  // import { sales } from '../../services/api/ExpertoRetail'
  // import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  export default {
    name: '',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: ['activeItem', 'listData'],
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {},
    data () {
      return {
        activeListItem: 0
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
      this.style = `height: ${this.vuexAvailableHeight}px; overflow: scroll; overflow-x:hidden;`
    },
    watch: {
      activeItem (id) {
        this.setItem(id)
      }
    },
    computed: {
      vuexAvailableHeight () {
        return this.$store.state.appAvailableHeight - 66
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      getIdFilter (id) {
        this.activeListItem = id
        this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', id)
        // this.$eventHub.$emit('dimension-filter-fetch-data')
      },
      setItem (id) {
        this.activeListItem = id
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/GeneralKeyKpiAnalysis/ProductWmRetailList.vue